import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { urlsConstants } from '../../../_constants/urls.constant';

const IntegracaoSSO = ({ dispatch, history }) => {
  useEffect(() => {
    const listener = async (event) => {
      console.log('Event Origin:', event.origin);

      const ALLOWED = new Set([
        'http://localhost:3000',
        'http://127.0.0.1:5500',
        'https://metadoctors.com.br',
        'https://metadoctors.com.br/app'
      ]);

      if (!ALLOWED.has(event.origin)) {
        console.warn('Origem não autorizada:', event.origin);
        return;
      }

      const { tokenEmpresa, tokenUsuario } = event.data;

      if (!tokenEmpresa || !tokenUsuario) {
        console.warn('Tokens inválidos recebidos:', event.data);
        return;
      }

      try {
        const response = await fetch(urlsConstants.INTEGRACAO_SSO_IFRAME, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tokenEmpresa, tokenUsuario }),
        });

        if (!response.ok) {
          dispatch.alert.error({
            message: 'Falha na autenticação SSO'
          });
          return;
        }

        const data = await response.json();

        if (data.acao === 'LOGIN_EXISTENTE') {
          try {
            await dispatch.authentication.ssoLogin({ cpf: data.cpf, perfil: 0 });
            history.push('/');
          } catch (err) {

            if (err && err.error_description === 'MULTI_PERFIL') {

              history.push({
                pathname: '/selectPerfil',
                state: { cpf: data.cpf },
              });
              return;
            }

            console.warn('Falha no SSO, erro não tratado:', err);
          }

        } else if (data.acao === 'REGISTRADO') {
          dispatch.alert.success({
            message: 'Registado com sucesso'
          });

        } else {
          console.warn('Ação desconhecida na resposta da integração:', data);
        }

      } catch (err) {
        console.error('Erro no fluxo SSO:', err);
        dispatch.alert.error({
          message: 'Erro no fluxo SSO:'
        })
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [dispatch, history]);

  return (
    <div>
      <h2>Autenticando via SSO...</h2>
    </div>
  );
};


export default connect()(withRouter(IntegracaoSSO));
